module.exports = __webpack_public_path__ + "static/media/add.50b94c0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/Add/add.png
// module id = 428
// module chunks = 0